import { copy } from '../copy.js';
import { renderPhotoStep } from './modem.js';

export function renderGateway(state, actions) {
  return renderPhotoStep({
    state,
    actions,
    step: 2,
    total: 4,
    slot: 'gateway',
    copy: copy.gateway,
    exampleSrc: '/assets/examples/gateway-example.jpg',
    nextScreen: 'ap',
    photo: state.photos.gateway,
  });
}
